import React, { Component } from "react";
import { DatePicker, Spin, message, Checkbox } from "antd";
import Bridge from "../../utils/Bridge";
import { speech_demographics_form_type } from "../../utils/consts";
import moment from "moment";
import dayjs from "dayjs";

export default class SymptomOnsetForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date_of_symptom_onset: null,
      gender:"",
      loading: false,
      email:"",
      neurostamp_id:"",
      modality_id:"",
      question_list:[],
      field_data:[],

      date_of_symptom_onset: null,
      date_of_diagnosis: null,
      clinic_or_hospital_name_and_city: "",
      neurologist_physician_name: "",

      // new fields
      generalized: false,
      bulbar: false,
      bulbar_speech: false,
      bulbar_swallowing: false,
      neck_weakness: false,
      trunk_weakness: false,
      respiratory: false,
      limb:false,
      limb_upper:false,
      limb_upper_right:false,
      limb_upper_right_hand_fingers:false,
      limb_upper_right_arm:false,
      limb_upper_left:false,
      limb_upper_left_hand_fingers:false,
      limb_upper_left_arm:false,
      limb_lower:false,
      limb_lower_right:false,
      limb_lower_right_ankle_foot_toes:false,
      limb_lower_right_leg:false,
      limb_lower_left:false,
      limb_lower_left_ankle_foot_toes:false,
      limb_lower_left_leg:false,

      symptom_other:false,
      symptom_other_specification:"",

    };
  }
  componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    this.get_demographic_details();
  }
  get_demographic_details = () => {
    let params = "?eals_id=" + localStorage.getItem("ap_eals_id");
    Bridge.demographics.ecas_study
      .get(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          if (response.data.length > 0) {
            for (let item of response.data) {
              if (item.field == "Your Neurologist or Physician name (who diagnosed you)?") {
                this.setState({
                  neurologist_physician_name: item.value ? item.value : "",
                });
              }
              if (item.field == "Clinic or Hospital name and city") {
                this.setState({
                  clinic_or_hospital_name_and_city: item.value ? item.value : "",
                });
              }
              if (item.field == "Date of Diagnosis") {
                this.setState({
                  date_of_diagnosis: item.value ? dayjs(item.value) : null,
                });
              }
              if (item.field == "Date of Symptom Onset") {
                this.setState({
                  date_of_symptom_onset: item.value ? dayjs(item.value) : null,
                });
              }

              if (item.field == "Generalized") {
                this.setState({ generalized: item.value == "1" ? true : false });
              }
              if (item.field == "Bulbar") {
                this.setState({ bulbar: item.value == "1" ? true : false });
              }
              if (item.field == "Bulbar Speech") {
                this.setState({ bulbar_speech: item.value == "1" ? true : false });
              }
              if (item.field == "Bulbar Swallowing") {
                this.setState({ bulbar_swallowing: item.value == "1" ? true : false });
              }
              if (item.field == "Neck Weakness") {
                this.setState({ neck_weakness: item.value == "1" ? true : false });
              }
              if (item.field == "Trunk Weakness") {
                this.setState({ trunk_weakness: item.value == "1" ? true : false });
              }
              if (item.field == "Respiratory") {
                this.setState({ respiratory: item.value == "1" ? true : false });
              }
              if (item.field == "Limb") {
                this.setState({ limb: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Upper") {
                this.setState({ limb_upper: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Upper Right") {
                this.setState({ limb_upper_right: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Upper Right Hand Fingers") {
                this.setState({ limb_upper_right_hand_fingers: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Upper Right Arm") {
                this.setState({ limb_upper_right_arm: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Upper Left") {
                this.setState({ limb_upper_left: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Upper Left Hand Fingers") {
                this.setState({ limb_upper_left_hand_fingers: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Upper Left Arm") {
                this.setState({ limb_upper_left_arm: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Lower") {
                this.setState({ limb_lower: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Lower Right") {
                this.setState({ limb_lower_right: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Lower Right Ankle Foot Toes") {
                this.setState({ limb_lower_right_ankle_foot_toes: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Lower Right Leg") {
                this.setState({ limb_lower_right_leg: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Lower Left") {
                this.setState({ limb_lower_left: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Lower Left Ankle Foot Toes") {
                this.setState({ limb_lower_left_ankle_foot_toes: item.value == "1" ? true : false });
              }
              if (item.field == "Limb Lower Left Leg") {
                this.setState({ limb_lower_left_leg: item.value == "1" ? true : false });
              }
              if (item.field == "Other") {
                this.setState({ symptom_other: item.value == "1" ? true : false });
              }
              if (item.field == "Other Specification") {
                this.setState({ symptom_other_specification: item.value });
              }
            }
          }
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  onChange = (date, dateString) => {
    this.setState({
      date_of_symptom_onset: date,
    });
  };
  save = () => {
    if (!this.state.date_of_diagnosis) {
      message.warning("Please select date of diagnosis");
      return;
    }
    if (!this.state.date_of_symptom_onset) {
      message.warning("Please select date of symptom onset");
      return;
    }
    if (!this.state.neurologist_physician_name) {
      message.warning("Please enter the value of 'Neurologist or Physician name'");
      return;
    }
    if (!this.state.clinic_or_hospital_name_and_city) {
      message.warning("Please enter the value of 'Clinic or Hospital name and city'");
      return;
    }   
    // step 2
    let questions = [
      {
        parent_field: "Your Neurologist or Physician name (who diagnosed you)?",
        field: "Your Neurologist or Physician name (who diagnosed you)?",
        value: this.state.neurologist_physician_name,
      },
      {
        parent_field: "Clinic or Hospital name and city",
        field: "Clinic or Hospital name and city",
        value: this.state.clinic_or_hospital_name_and_city,
      },
      {
        parent_field: "Date of Diagnosis",
        field: "Date of Diagnosis",
        value: this.state.date_of_diagnosis?dayjs(this.state.date_of_diagnosis).format('MM/DD/YYYY'):"",
      },
      {
        parent_field: "Date of Symptom Onset",
        field: "Date of Symptom Onset",
        value:  this.state.date_of_symptom_onset?dayjs(this.state.date_of_symptom_onset).format('MM/DD/YYYY'):"",
      },
      {
        parent_field: "Site of Onset",
        field: "Generalized",
        value: this.state.generalized ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Bulbar",
        value: this.state.bulbar ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Bulbar Speech",
        value: this.state.bulbar_speech ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Bulbar Swallowing",
        value: this.state.bulbar_swallowing ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Neck Weakness",
        value: this.state.neck_weakness ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Trunk Weakness",
        value: this.state.trunk_weakness ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Respiratory",
        value: this.state.respiratory ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb",
        value: this.state.limb ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Upper",
        value: this.state.limb_upper ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Upper Right",
        value: this.state.limb_upper_right ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Upper Right Hand Fingers",
        value: this.state.limb_upper_right_hand_fingers ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Upper Right Arm",
        value: this.state.limb_upper_right_arm ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Upper Left",
        value: this.state.limb_upper_left ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Upper Left Hand Fingers",
        value: this.state.limb_upper_left_hand_fingers ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Upper Left Arm",
        value: this.state.limb_upper_left_arm ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Lower",
        value: this.state.limb_lower ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Lower Right",
        value: this.state.limb_lower_right ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Lower Right Ankle Foot Toes",
        value: this.state.limb_lower_right_ankle_foot_toes ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Lower Right Leg",
        value: this.state.limb_lower_right_leg ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Lower Left",
        value: this.state.limb_lower_left ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Lower Left Ankle Foot Toes",
        value: this.state.limb_lower_left_ankle_foot_toes ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Limb Lower Left Leg",
        value: this.state.limb_lower_left_leg ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Other",
        value: this.state.symptom_other ? "1" : "0",
      },
      {
        parent_field: "Site of Onset",
        field: "Other Specification",
        value: this.state.symptom_other_specification,
      },
    ];
    let params = {
      eals_id: localStorage.getItem("ap_eals_id"),
      data: JSON.stringify(questions),
      step: "2",
      action_type: this.props.is_update == true ? "update" : "insert",
    };
    this.setState({ loading: true });
    Bridge.demographics.ecas_study
      .save(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              if (this.props.is_update == true) {
                setTimeout(() => {
                  window.location.assign("/about-me");
                }, 3000);
              } else {
                this.props.set_active_step(3);
              }
            }
          );
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    const disabledDate = (current) => {
      // Disable all dates after today
      return current && current > moment().subtract(18, "years");
    };
    return (
      <div>
        <div className="header">
          <h3 className="text-uppercase">Symptom Onset</h3>
          <div className="white-block"></div>
        </div>
        <Spin spinning={this.state.loading}>
          <div className="form-fields">
            <div className="form-group">
              <label className="mb-2 input-heading">
                Date of Diagnosis:{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <DatePicker
                onChange={(date, dateString) => {
                  this.setState({
                    date_of_diagnosis: date,
                  });
                }}
                format={"MM/DD/YYYY"}
                value={this.state.date_of_diagnosis}
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Date of symptom onset:{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <DatePicker
                onChange={this.onChange}
                format={"MM/DD/YYYY"}
                value={this.state.date_of_symptom_onset}
                style={{
                  width: "100%",
                  height: 55,
                  maxWidth: 500,
                }}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
              Your Neurologist or Physician name (who diagnosed you)?{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <input
                type="text"
                className="form-control mt-3"
                value={this.state.neurologist_physician_name}
                onChange={(e)=>this.setState({neurologist_physician_name:e.target.value})}
              />
            </div>
            <div className="form-group">
              <label className="mb-2 input-heading">
                Clinic or Hospital name and city{" "}
                <span className="text-danger">*</span>
              </label>
              <br />
              <input
                type="text"
                className="form-control mt-3"
                value={this.state.clinic_or_hospital_name_and_city}
                onChange={(e)=>this.setState({clinic_or_hospital_name_and_city:e.target.value})}
              />
            </div>
            
            
            <div className="">
              <label className="input-heading mb-0">
                Site of Symptom Onset:
              </label>
            </div>
            <div className="form-group">
              <br/>
              <div className="symptom-checkboxs">
                <li>
                  <Checkbox
                    checked={this.state.generalized}
                    onChange={(e)=>this.setState({generalized:e.target.checked})}
                  >Generalized
                  </Checkbox>
                </li>
                <div class="form-group mb-4 mt-3" data-field-oid="DMALSF06" data-field-name="new_field876880"><label class="form-label font-weight-bold mb-0" style={{fontWeight:"800"}}>__________________</label></div>
              </div>
              <br/>
              <div className="symptom-checkboxs">
                <li>
                  <Checkbox
                    checked={this.state.bulbar}
                    onChange={(e)=>this.setState({
                      bulbar:e.target.checked, bulbar_speech:false, bulbar_swallowing:false
                    })}
                  >Bulbar
                  </Checkbox>
                </li>
                <div style={{paddingLeft:25}}>
                  <li>
                    <Checkbox
                      checked={this.state.bulbar_speech}
                      disabled={this.state.bulbar==true ? false:true}
                      onChange={(e)=>this.setState({bulbar_speech:e.target.checked})}
                    >Speech
                    </Checkbox>
                  </li>
                  <li>
                    <Checkbox
                      checked={this.state.bulbar_swallowing}
                      disabled={this.state.bulbar==true ? false:true}
                      onChange={(e)=>this.setState({bulbar_swallowing:e.target.checked})}
                    >Swallowing
                    </Checkbox>
                  </li>
                </div>
                <div class="form-group mb-4 mt-3" data-field-oid="DMALSF06" data-field-name="new_field876880"><label class="form-label font-weight-bold mb-0" style={{fontWeight:"800"}}>___________________________</label></div>
              </div>

              <div className="symptom-checkboxs">
                <li>
                  <Checkbox
                    onChange={
                      (e)=>this.setState({neck_weakness:e.target.checked})
                    }
                    checked={this.state.neck_weakness}
                  >
                    Neck Weakness
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    onChange={
                      (e)=>this.setState({
                        trunk_weakness:e.target.checked,
                      })
                    }
                    checked={this.state.trunk_weakness}
                  >
                    Trunk Weakness
                  </Checkbox>
                </li>
                <li>
                  <Checkbox
                    onChange={
                      (e)=>this.setState({respiratory:e.target.checked})
                    }
                    checked={this.state.respiratory}
                  >
                    Respiratory
                  </Checkbox>
                </li>
                
                <div class="form-group mb-4 mt-3" data-field-oid="DMALSF06" data-field-name="new_field876880"><label class="form-label font-weight-bold mb-0" style={{fontWeight:"800"}}>___________________________</label></div>
              </div>

              <div className="symptom-checkboxs">
                <li className="pb-1">
                  <Checkbox
                    onChange={
                      (e)=>this.setState({
                        limb:e.target.checked,
                        limb_upper:false,
                        limb_upper_right:false,
                        limb_upper_right_hand_fingers:false,
                        limb_upper_right_arm:false,
                        limb_upper_left:false,
                        limb_upper_left_hand_fingers:false,
                        limb_upper_left_arm:false,
                        limb_lower:false,
                        limb_lower_right:false,
                        limb_lower_right_ankle_foot_toes:false,
                        limb_lower_right_leg:false,
                        limb_lower_left:false,
                        limb_lower_left_ankle_foot_toes:false,
                        limb_lower_left_leg:false,
                      })
                    }
                    checked={this.state.limb}
                  >
                    Limb
                  </Checkbox>
                </li>
                <li className="pb-1 pl-4">
                  <Checkbox
                    onChange={
                      (e)=>this.setState({
                        limb_upper:e.target.checked,
                        limb_upper_right:false,
                        limb_upper_right_hand_fingers:false,
                        limb_upper_right_arm:false,
                        limb_upper_left:false,
                        limb_upper_left_hand_fingers:false,
                        limb_upper_left_arm:false,
                      })
                    }
                    checked={this.state.limb_upper}
                    disabled={this.state.limb==true ?false: true}
                  >
                    Upper
                  </Checkbox>
                </li>
                <div style={{paddingLeft:25}}>
                  <li className="pb-1 pl-4">
                    <Checkbox
                      onChange={
                        (e)=>this.setState({
                          limb_upper_right:e.target.checked,
                          limb_upper_right_hand_fingers:false,
                          limb_upper_right_arm:false,
                        })
                      }
                      checked={this.state.limb_upper_right}
                      disabled={this.state.limb_upper==true ?false: true}
                    >
                      Right
                    </Checkbox>
                  </li>
                  <div style={{paddingLeft:25}}> 
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={
                          (e)=>this.setState({limb_upper_right_hand_fingers:e.target.checked})
                        }
                        checked={this.state.limb_upper_right_hand_fingers}
                        disabled={this.state.limb_upper_right==true ?false: true}
                      >
                        Hand/Fingers
                      </Checkbox>
                    </li>
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={
                          (e)=>this.setState({limb_upper_right_arm:e.target.checked})
                        }
                        checked={this.state.limb_upper_right_arm}
                        disabled={this.state.limb_upper_right==true ?false: true}
                      >
                        Arm
                      </Checkbox>
                    </li>
                  </div>
                  <li className="pb-1 pl-4">
                    <Checkbox
                      onChange={
                        (e)=>this.setState({
                          limb_upper_left:e.target.checked,
                          limb_upper_left_hand_fingers:false,
                          limb_upper_left_arm:false,
                        })
                      }
                      checked={this.state.limb_upper_left}
                      disabled={this.state.limb_upper==true ?false: true}
                    >
                      Left
                    </Checkbox>
                  </li>
                  <div style={{paddingLeft:25}}> 
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={
                          (e)=>this.setState({limb_upper_left_hand_fingers:e.target.checked})
                        }
                        checked={this.state.limb_upper_left_hand_fingers}
                        disabled={this.state.limb_upper_left==true ?false: true}
                      >
                        Hand/Fingers
                      </Checkbox>
                    </li>
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={
                          (e)=>this.setState({limb_upper_left_arm:e.target.checked})
                        }
                        checked={this.state.limb_upper_left_arm}
                        disabled={this.state.limb_upper_left==true ?false: true}
                      >
                        Arm
                      </Checkbox>
                    </li>
                  </div>
                </div>
                <li className="pb-1 pl-4">
                  <Checkbox
                    onChange={
                      (e)=>this.setState({
                        limb_lower:e.target.checked,  
                        limb_lower_right:false,
                        limb_lower_right_ankle_foot_toes:false,
                        limb_lower_right_leg:false,
                        limb_lower_left:false,
                        limb_lower_left_ankle_foot_toes:false,
                        limb_lower_left_leg:false,   
                      })
                    }
                    checked={this.state.limb_lower}
                    disabled={this.state.limb==true ?false: true}
                  >
                    Lower
                  </Checkbox>
                </li>
                <div style={{paddingLeft:25}}>
                  <li className="pb-1 pl-4">
                    <Checkbox
                      onChange={
                        (e)=>this.setState({
                          limb_lower_right:e.target.checked,
                          limb_lower_right_ankle_foot_toes:false,
                          limb_lower_right_leg:false,
                        })
                      }
                      checked={this.state.limb_lower_right}
                      disabled={this.state.limb_lower==true ?false: true}
                    >
                      Right
                    </Checkbox>
                  </li>
                  <div style={{paddingLeft:25}}> 
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={
                          (e)=>this.setState({limb_lower_right_ankle_foot_toes:e.target.checked})
                        }
                        checked={this.state.limb_lower_right_ankle_foot_toes}
                        disabled={this.state.limb_lower_right==true ?false: true}
                      >
                        Ankle/Foot/Toes
                      </Checkbox>
                    </li>
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={
                          (e)=>this.setState({limb_lower_right_leg:e.target.checked})
                        }
                        checked={this.state.limb_lower_right_leg}
                        disabled={this.state.limb_lower_right==true ?false: true}
                      >
                        Leg
                      </Checkbox>
                    </li>
                  </div>
                  <li className="pb-1 pl-4">
                    <Checkbox
                      onChange={
                        (e)=>this.setState({
                          limb_lower_left:e.target.checked,
                          limb_lower_left_ankle_foot_toes:false,
                          limb_lower_left_leg:false,
                        })
                      }
                      checked={this.state.limb_lower_left}
                      disabled={this.state.limb_lower==true ?false: true}
                    >
                      Left
                    </Checkbox>
                  </li>
                  <div style={{paddingLeft:25}}> 
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={
                          (e)=>this.setState({limb_lower_left_ankle_foot_toes:e.target.checked})
                        }
                        checked={this.state.limb_lower_left_ankle_foot_toes}
                        disabled={this.state.limb_lower_left==true ?false: true}
                      >
                        Ankle/Foot/Toes
                      </Checkbox>
                    </li>
                    <li className="pb-1 pl-4">
                      <Checkbox
                        onChange={
                          (e)=>this.setState({limb_lower_left_leg:e.target.checked})
                        }
                        checked={this.state.limb_lower_left_leg}
                        disabled={this.state.limb_lower_left==true ?false: true}
                      >
                        Leg
                      </Checkbox>
                    </li>
                  </div>
                </div>
                <div class="form-group mb-4 mt-3" data-field-oid="DMALSF06" data-field-name="new_field876880"><label class="form-label font-weight-bold mb-0" style={{fontWeight:"800"}}>___________________________</label></div>
              </div>

              <div className="symptom-checkboxs">
                <li>
                  <Checkbox
                    checked={this.state.symptom_other}
                    onChange={(e)=>this.setState({symptom_other:e.target.checked,symptom_other_specification:""})}
                  >Other Please Specify:
                  </Checkbox>
                </li>
                <li>
                  {this.state.symptom_other == true && (
                    <input
                      type="text"
                      className="form-control mt-3"
                      placeholder="Please Specify"
                      value={this.state.symptom_other_specification}
                      onChange={(e)=>this.setState({symptom_other_specification:e.target.value})}
                    />
                  )}
                </li>
              </div>
            </div>
            
            {this.props.is_update == true ? (
              <div className="d-flex mt-5">
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 0,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            ) : (
              <div className="d-flex mt-5">
                <button
                  style={{
                    padding: "9px 28px 10px 21px",
                    // background: "#b3b3b3",
                    // cursor: "auto",
                  }}
                  className="submit-button"
                  onClick={() =>{
                      this.props.set_active_step(1);
                  }}
                >
                  <box-icon
                    name="chevron-left"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                  Previous
                </button>
                <button
                  className="submit-button ml-2"
                  style={{
                    marginLeft: 17,
                    padding: "9px 15px 10px 20px",
                  }}
                  onClick={() => this.save()}
                >
                  Save & Next{" "}
                  <box-icon
                    name="chevron-right"
                    color="#fff"
                    style={{ position: "relative", top: 1 }}
                  ></box-icon>
                </button>
              </div>
            )}
          </div>
        </Spin>
      </div>
    );
  }
}
